module.exports = __webpack_public_path__ + "media/images/iconPlus__errorRed--dark-fcc6dc759473302272bdcdbf22b06b4d.png";